import flowRight from "lodash/flowRight";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { makeSelectCurOrg } from "logic/orgs";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import DefaultBg from "../assets/img/default-bg.png";

const Background = ({ noBlur, className, imgSrc, image, header, children }) => {
  const bgStyles = {};

  const imageDesc =
    image && (image.description || image.copyright)
      ? `${image.description}${
          image.description && image.description.length > 0 ? " - " : ""
        }Copyright: ${image.copyright}`
      : null;

  bgStyles.backgroundImage = `url(${imgSrc ? imgSrc : DefaultBg})`;

  if (header)
    return (
      <div className={classNames("tt-header-bg-wrap", className)}>
        <figure className="tt-header-bg" style={bgStyles} title={imageDesc}>
          {image ? (
            <>
              {!isEmpty(image.copyright) ? (
                <footer>
                  <small>Copyright: {image.copyright}</small>
                </footer>
              ) : null}
              {!isEmpty(image.description) ? (
                <figcaption>{image.description}</figcaption>
              ) : null}
            </>
          ) : null}
        </figure>
        {children}
      </div>
    );

  return (
    <div className={classNames("tt-bg-img-wrap", className)}>
      <div
        className={classNames("tt-bg-img", noBlur ? "" : "blurred")}
        style={bgStyles}
        title={imageDesc}
      >
        {children}
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
});

const enhance = flowRight(connect(mapStateToProps));

export default enhance(Background);
